export const LOAD = 'success/LOAD';

export const POWERS_DETAIL_LOAD = 'success/POWERS_DETAIL_LOAD';
export const POWERS_DETAIL_FAIL = 'success/POWERS_DETAIL_FAIL';
export const POWERS_DETAIL_SUCCESS = 'success/POWERS_DETAIL_SUCCESS';

// export const SET_ACTIVE_FRAME = 'success/SET_ACTIVE_FRAME';

export const SAVED_PRESCRIPTION_LOAD = 'success/SAVED_PRESCRIPTION_LOAD';
export const SAVED_PRESCRIPTION_FAIL = 'success/SAVED_PRESCRIPTION_FAIL';
export const SAVED_PRESCRIPTION_SUCCESS = 'success/SAVED_PRESCRIPTION_SUCCESS';

export const SUBMIT_POWERS_LOAD = 'success/SUBMIT_POWERS_LOAD';
export const SUBMIT_POWERS_FAIL = 'success/SUBMIT_POWERS_FAIL';
export const SUBMIT_POWERS_SUCCESS = 'success/SUBMIT_POWERS_SUCCESS';

export const SUBMITTED_POWERS_LOAD = 'success/SUBMITTED_POWERS_LOAD';
export const SUBMITTED_POWERS_FAIL = 'success/SUBMITTED_POWERS_FAIL';
export const SUBMITTED_POWERS_SUCCESS = 'success/SUBMITTED_POWERS_SUCCESS';

export const OTP_SUBMISSION_LOAD = 'success/OTP_SUBMISSION_LOAD';
export const OTP_SUBMISSION_FAIL = 'success/OTP_SUBMISSION_FAIL';
export const OTP_SUBMISSION_SUCCESS = 'success/OTP_SUBMISSION_SUCCESS';

export const SUBMISSION_SUCCESS = 'success/SUBMISSION_SUCCESS';

export const MSG_ERROR = 'success/MSG_ERROR';

export const ENTER_DATA = 'success/ENTER_DATA';

export const ACTIVE_FRAME_DATA = 'success/ACTIVE_FRAME_DATA';

export const SHOW_DD = 'success/SHOW_DD';

export const SUBMIT_PACKAGE_LOAD = 'success/SUBMIT_PACKAGE_LOAD';
export const SUBMIT_PACKAGE_FAIL = 'success/SUBMIT_PACKAGE_FAIL';
export const SUBMIT_PACKAGE_SUCCESS = 'success/SUBMIT_PACKAGE_SUCCESS';

export const RESET_STATE = 'success/RESET_STATE';

